import { initializeApp } from 'firebase/app';
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, getFirestore, limit, orderBy, query, setDoc, startAfter, updateDoc, where } from "firebase/firestore";
import { getDownloadURL, getStorage, ref, uploadString } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDILUP0wEUOL07HY1GYUDU4KE3fo0KNtdE",
  authDomain: "coloringclub-6a29b.firebaseapp.com",
  projectId: "coloringclub-6a29b",
  storageBucket: "coloringclub-6a29b.appspot.com",
  messagingSenderId: "726359129051",
  appId: "1:726359129051:web:a00dd9d7b5d208e31705fe",
  measurementId: "G-KL2L5GD7GJ"
}

const app = initializeApp(firebaseConfig)
const db = getFirestore(app);
const storage = getStorage()

function getUTC_TIME() {
  return new Date(new Date().toUTCString()).getTime()
}

export function docIdFromDrawingAndUser(drawingId, userId) {
  return drawingId + '-' + userId
}

export async function fetchAllDrawings() {
  const querySnapshot = await getDocs(collection(db, "all_drawings_new"));
  if (!querySnapshot.docs[0]) return []

  const map = querySnapshot.docs[0].data().map
  return Object.keys(map).map(key => map[key]);
}

export async function fetchDrawingById(id) {
  const docSnap = await getDoc(doc(db, "drawings", id));

  if (docSnap.exists()) {
    return docSnap.data()
  } else {
    console.log(`Document [id: ${id}] does not exist`)
    return {}
  }
}

export async function fetchAllCategories() {
  const querySnapshot = await getDocs(collection(db, 'categories'))
  const categories = []

  querySnapshot.forEach((doc) => {
    categories.push({ id: doc.id, ...doc.data() })
  });

  return categories;
}

// TODO: use "user_coloring_history"
export async function fetchColoringHistory(userId) {
  const coloringHistory = []
  const q = query(collection(db, 'coloring_history'), where('userId', '==', userId))
  const querySnapshot = await getDocs(q)

  querySnapshot.forEach((doc) => {
    coloringHistory.push({ id: doc.id, ...doc.data() })
  });

  return coloringHistory;
}

/* Coloring Actions */
export async function fetchColoringActions(drawingId, userId) {
  const docId = docIdFromDrawingAndUser(drawingId, userId)

  try {
    const docSnap = await getDoc(doc(db, "coloring_history", docId))

    if (docSnap.exists()) {
      return docSnap.data()
    } else {
      console.log(`Document [id: ${docId}] does not exist`)
      return null
    }
  } catch (err) {
    console.debug(`Document [id: ${docId}] does not exist`)
  }
}

export function saveColoringActions(drawingId, userId, actions, imageUrl) {
  const docId = docIdFromDrawingAndUser(drawingId, userId)

  const data = {
    userId,
    drawingId,
    updatedAt: getUTC_TIME(),
    actions,
    imageUrl,
  }

  return setDoc(doc(db, 'coloring_history', docId), data)
}

export function uploadImageDataUrl(docId, dataUrl) {
  const storageRef = ref(storage, 'post_images/' + docId)

  return uploadString(storageRef, dataUrl, 'data_url')
    .then(async ({ ref }) => {
      console.log('Uploaded a data_url string!', await getDownloadURL(ref));
      return await getDownloadURL(ref)
    })
}

/* Posts */
export function createPost(drawingId, userId, imageUrl, text) {
  const data = {
    userId,
    drawingId,
    createdAt: getUTC_TIME(),
    imageUrl,
    text,
  }

  return addDoc(collection(db, 'user_posts'), data)
}

export async function fetchPostsFirstBatch(userId) {
  const posts = []

  let q
  if (userId) {
    // Fetch user posts, used in the profile page
    q = query(collection(db, 'user_posts'), orderBy('createdAt', 'desc'), where('userId', '==', userId), limit(5));
  } else {
    q = query(collection(db, 'user_posts'), orderBy('createdAt', 'desc'), limit(5));
  }

  const querySnapshot = await getDocs(q)

  querySnapshot.forEach((doc) => {
    posts.push({
      ...doc.data(),
      id: doc.id,
    })
  })

  return posts
}

export async function fetchPostsNextBatch(lastCreatedAt, userId) {
  const posts = []

  let q
  if (userId) {
    // Fetch user posts, used in the profile page
    q = query(collection(db, 'user_posts'), orderBy('createdAt', 'desc'), startAfter(lastCreatedAt), where('userId', '==', userId), limit(5));
  } else {
    q = query(collection(db, 'user_posts'), orderBy('createdAt', 'desc'), startAfter(lastCreatedAt), limit(5));
  }

  const querySnapshot = await getDocs(q)

  querySnapshot.forEach((doc) => {
    posts.push({
      ...doc.data(),
      id: doc.id,
    })
  })

  return posts
}

export function deletePost(postId) {
  return deleteDoc(doc(db, 'user_posts', postId))
    .then(() => ({ postId }))
}

export function updatePost(postId, text) {
  return updateDoc(doc(db, 'user_posts', postId), { text })
    .then(() => ({ postId, text }))
}

/* Comments */
export function createComment(postId, userId, text, postAuthorId) {
  const data = {
    userId,
    postId,
    postAuthorId,
    createdAt:  getUTC_TIME(),
    text,
  }

  return addDoc(collection(db, 'post_comments'), data)
    .then((ref) => ({ ...data, commentId: ref.id }))
}

export function deleteComment(commentId, postId) {
  return deleteDoc(doc(db, 'post_comments', commentId))
    .then(() => ({ commentId, postId }))
}

export function updateComment(commentId, postId, text) {
  return updateDoc(doc(db, 'post_comments', commentId), { text })
    .then(() => ({ commentId, postId, text }))
}

/* Reactions */
export function createReaction(postId, userId, postAuthorId) {
  const data = {
    userId,
    postId,
    postAuthorId,
    createdAt: getUTC_TIME(),
  }

  return addDoc(collection(db, 'post_reactions'), data)
    .then((ref) => ({ ...data, reactionId: ref.id }))
}

export function deleteReaction(reactionId, postId) {
  return deleteDoc(doc(db, 'post_reactions', reactionId))
    .then(() => ({ reactionId, postId }))
}

/* User Info */
export async function fetchAllUsers() {
  try {
    const docSnap = await getDoc(doc(db, "all_users", 'vqbsOx3yGPsW1EhgHHwY'))

    if (docSnap.exists()) {
      return docSnap.data().data
    } else {
      return null
    }
  } catch (err) {
    console.log(`Error fetching all_users document:`, err)
  }
}

export async function fetchUserInfo(userId) {
  const docSnap = await getDoc(doc(db, 'users', userId))

  if(docSnap.exists) {
    return docSnap.data()
  } else {
    return null
  }
}

export async function updateUserInfo(userId, data) {
  return updateDoc(doc(db, 'users', userId), { ...data })
}
